import { makeConstantFactory } from 'utils/constantsHelper'
import keyMirror from 'keymirror'
const makeConstant = makeConstantFactory('user')

export const UserStatus = keyMirror({
  ENABLED: null,
  ARCHIVED: null,
  INVITED: null,
})

export const AvailabilityStatus = {
  ACTIVE: 'AVAILABLE',
  AWAY: 'OFFLINE',
  ON_CALL: 'ON_CALL',
}

export const RANDOM_USER = Object.freeze({
  id: 0,
  name: 'Random Teammate',
})

export const FETCH_CLEARBIT_FOR_EMAIL = makeConstant('FETCH_CLEARBIT_FOR_EMAIL')
export const FETCH_CLEARBIT_FOR_EMAIL_SUCCESS = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_SUCCESS')
export const FETCH_CLEARBIT_FOR_EMAIL_FAILED = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_FAILED')
export const FETCH_CLEARBIT_FOR_EMAIL_PENDING = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_PENDING')

export const FETCH_GOOGLE_SCOPES = makeConstant('FETCH_GOOGLE_SCOPES')
export const FETCH_GOOGLE_SCOPES_SUCCESS = makeConstant('FETCH_GOOGLE_SCOPES_SUCCESS')
export const FETCH_GOOGLE_SCOPES_FAILED = makeConstant('FETCH_GOOGLE_SCOPES_FAILED')
export const FETCH_GOOGLE_SCOPES_PENDING = makeConstant('FETCH_GOOGLE_SCOPES_PENDING')

export const FETCH_EMAIL_SIGNATURE = makeConstant('FETCH_EMAIL_SIGNATURE')
export const FETCH_EMAIL_SIGNATURE_SUCCESS = makeConstant('FETCH_EMAIL_SIGNATURE_SUCCESS')
export const FETCH_EMAIL_SIGNATURE_FAILED = makeConstant('FETCH_EMAIL_SIGNATURE_FAILED')
export const FETCH_EMAIL_SIGNATURE_PENDING = makeConstant('FETCH_EMAIL_SIGNATURE_PENDING')

export const RESET_EMAIL_SIGNATURE = makeConstant('RESET_EMAIL_SIGNATURE')

export const SET_EMAIL_SIGNATURE = makeConstant('SET_EMAIL_SIGNATURE')
export const SET_EMAIL_SIGNATURE_SUCCESS = makeConstant('SET_EMAIL_SIGNATURE_SUCCESS')
export const SET_EMAIL_SIGNATURE_FAILED = makeConstant('SET_EMAIL_SIGNATURE_FAILED')

export const FETCH_CURRENT_USER_STARTED = makeConstant('FETCH_CURRENT_USER_STARTED')
export const FETCH_CURRENT_USER_FAILED = makeConstant('FETCH_CURRENT_USER_FAILED')
export const PATCH_CURRENT_USER_STARTED = makeConstant('PATCH_CURRENT_USER_STARTED')
export const PATCH_CURRENT_USER_FAILED = makeConstant('PATCH_CURRENT_USER_FAILED')
export const RECEIVE_CURRENT_USER = makeConstant('RECEIVE_CURRENT_USER')

export const FETCH_USER_STARTED = makeConstant('FETCH_USER_STARTED')
export const FETCH_USER_FAILED = makeConstant('FETCH_USER_FAILED')
export const RECEIVE_USER = makeConstant('RECEIVE_USER')

export const FETCH_ORG_USERS_STARTED = makeConstant('FETCH_ORG_USERS_STARTED')
export const FETCH_ORG_USERS_FAILED = makeConstant('FETCH_ORG_USERS_FAILED')

export const RECEIVE_ORG_USERS = makeConstant('RECEIVE_ORG_USERS')
export const RECEIVE_ORG_USER = makeConstant('RECEIVE_ORG_USER')

export const RECEIVE_GATES = makeConstant('RECEIVE_GATES')

export const TURN_OFF_MANUAL_AWAY = makeConstant('TURN_OFF_MANUAL_AWAY')
export const TURN_OFF_MANUAL_AWAY_PENDING = makeConstant('TURN_OFF_MANUAL_AWAY_PENDING')
export const TURN_OFF_MANUAL_AWAY_SUCCESS = makeConstant('TURN_OFF_MANUAL_AWAY_SUCCESS')
export const TURN_OFF_MANUAL_AWAY_FAILURE = makeConstant('TURN_OFF_MANUAL_AWAY_FAILURE')

export const FETCH_ORG_SIGNATURE = makeConstant('FETCH_ORG_SIGNATURE')
export const FETCH_ORG_SIGNATURE_PENDING = makeConstant('FETCH_ORG_SIGNATURE_PENDING')
export const FETCH_ORG_SIGNATURE_FAILED = makeConstant('FETCH_ORG_SIGNATURE_FAILED')
export const FETCH_ORG_SIGNATURE_SUCCESS = makeConstant('FETCH_ORG_SIGNATURE_SUCCESS')
export const FETCH_ORG_SIGNATURE_CANCELLED = makeConstant('FETCH_ORG_SIGNATURE_CANCELLED')

export const FETCH_ORG_MULTI_SIGNATURE = makeConstant('FETCH_ORG_MULTI_SIGNATURE')
export const FETCH_ORG_MULTI_SIGNATURE_PENDING = makeConstant('FETCH_ORG_MULTI_SIGNATURE_PENDING')
export const FETCH_ORG_MULTI_SIGNATURE_FAILED = makeConstant('FETCH_ORG_MULTI_SIGNATURE_FAILED')
export const FETCH_ORG_MULTI_SIGNATURE_SUCCESS = makeConstant('FETCH_ORG_MULTI_SIGNATURE_SUCCESS')
export const FETCH_ORG_MULTI_SIGNATURE_CANCELLED = makeConstant('FETCH_ORG_MULTI_SIGNATURE_CANCELLED')

export const DISCONNECT_GMAIL_ACCOUNT = makeConstant('DISCONNECT_GMAIL_ACCOUNT')
export const DISCONNECT_GMAIL_ACCOUNT_PENDING = makeConstant('DISCONNECT_GMAIL_ACCOUNT_PENDING')
export const DISCONNECT_GMAIL_ACCOUNT_SUCCESS = makeConstant('DISCONNECT_GMAIL_ACCOUNT_SUCCESS')
export const DISCONNECT_GMAIL_ACCOUNT_FAILURE = makeConstant('DISCONNECT_GMAIL_ACCOUNT_FAILURE')

export const FETCH_INDIVIDUAL_USER_CONVO_LIMIT = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT')
export const FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING')
export const FETCH_INDIVIDUAL_USER_CONVO_LIMIT_FAILED = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_FAILED')
export const FETCH_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS')
export const FETCH_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED')

export const UPDATE_INDIVIDUAL_USER_CONVO_LIMIT = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT')
export const UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_PENDING = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_PENDING')
export const UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_FAILED = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_FAILED')
export const UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS')
export const UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED')

export const UPDATE_USER = makeConstant('UPDATE_USER')
export const UPDATE_USER_PENDING = makeConstant('UPDATE_USER_PENDING')
export const UPDATE_USER_FAILED = makeConstant('UPDATE_USER_FAILED')
export const UPDATE_USER_SUCCESS = makeConstant('UPDATE_USER_SUCCESS')
export const UPDATE_USER_CANCELLED = makeConstant('UPDATE_USER_CANCELLED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/constants.js